export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13193.fb243b0c.jpg";